import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useAccountSummaryV2Query } from '@syf-api-library/account-summary';
import query from 'syf-component-library/const/mediaQueries';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
import { t } from '../../../translations/getTranslation';
import useConfig from '../../../context/config.context';
const InsetContainer = styled(Inset) `
  display: flex;
  align-items: center;
  border-bottom: 2px solid ${({ theme }) => theme.colors.aliceBlue};
  padding: ${({ theme }) => `${theme.spacing.medium}px ${theme.spacing.base}px`};

  @media ${query.greaterThanMedium} {
    padding: ${({ theme }) => `${theme.spacing.large}px ${theme.spacing.base}px`};
  }
`;
const CardInfoWrapper = styled.div `
  display: flex;
  flex-direction: row;
`;
const InfoWrapper = styled.div `
  display: flex;
  flex-direction: column;
  margin-left: ${({ theme }) => theme.spacing.base}px;
`;
const ImageWrapper = styled.div `
  height: 56px;
`;
const Image = styled.img `
  height: auto;
  width: auto;
  max-height: 100%;
  max-width: 100%;
`;
const DescriptionContainer = styled(Body) `
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.medium}px;
  line-height: ${({ theme }) => theme.lineHeights.medium};
`;
const AccountInfo = styled(Body) `
  font-size: ${({ theme }) => theme.fontSizes.root}px;
  line-height: ${({ theme }) => theme.lineHeights.root};
`;
const defaultCardArt = 'https://qa.synchronycredit.com/assets/cardArt/syf_generic_card.svg';
const CardInfo = () => {
    var _a, _b, _c, _d;
    const { config, accountId } = useConfig();
    const { data } = useAccountSummaryV2Query({
        config,
        keyProps: { accountId, accountIdType: 'guid' }
    });
    return (_jsx(InsetContainer, Object.assign({ all: "base" }, { children: _jsxs(CardInfoWrapper, { children: [_jsx(ImageWrapper, { children: _jsx(Image, { src: (_b = (_a = data === null || data === void 0 ? void 0 : data.card) === null || _a === void 0 ? void 0 : _a.cardArtURL) !== null && _b !== void 0 ? _b : defaultCardArt, alt: "Card Art" }) }), _jsxs(InfoWrapper, { children: [_jsx(DescriptionContainer, { children: ((_c = data === null || data === void 0 ? void 0 : data.product) === null || _c === void 0 ? void 0 : _c.displayName) || '' }), _jsx(AccountInfo, { children: t('common.accountEndingIn', {
                                last4digits: ((_d = data === null || data === void 0 ? void 0 : data.accountInfo) === null || _d === void 0 ? void 0 : _d.accountLast4) || ''
                            }) })] })] }) })));
};
export default CardInfo;
//# sourceMappingURL=index.js.map